import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';

import { Observable } from 'rxjs/Rx';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { BaseService } from './base.service';
import { Admin } from './../models/admin';
import { Client } from './../models/client';
import { Implant, InfoCasseBanner, NuovoProprietarioVM } from '../models/implant';
import { Offerta } from '../models/offerta';
import { ServizioPerImpianto, Servizio, ServizioPerListino } from '../models/servizio';
import { Evento, Eventi } from "../models/evento";
import { RichiestaCrediti, Richiesta } from "../models/richiesta-crediti";
import { Cassa } from '../models/cassa';
import { FotoTotem } from '../models/fotoTotem';
import { Listino } from '../models/listino';
import { OperatoreImpianto, CheckEmailBM, CheckEmailVM } from '../models/operatoreImpianto';

@Injectable()
export class AdminService extends BaseService {

  ///////////////////----------ADMINS


  getAdmins(): Observable<Admin[]> {
    return this.get('api/amministratori/')
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response.Amministratori;
      });
  }

  getAdmin(AdminId): Observable<Admin> {
    return this.get('api/amministratori/' + AdminId)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  postAdmin(Form): Observable<number> {
    return this.post('api/amministratori', Form)
      .catch((error: any) => { console.log("postAdmin: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return response;
      });
  }

  putAdmin(Form: Admin): Observable<boolean> {
    return this.put('api/amministratori/' + Form.Id, Form)
      .catch((error: any) => { console.log("putAdmin: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  deleteAdmin(Id): Observable<boolean> {
    return this.delete('api/amministratori/' + Id)
      .catch((error: any) => { console.log("deleteAdmin: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  putModificaPasswordAdmin(idAdmin: string, password: string): Observable<boolean> {
    var Form: any = {};
    Form.Id = idAdmin;
    Form.Password = password;
    return this.put('api/amministratori/' + Form.Id + '/modificapassword', Form)
      .catch((error: any) => { console.log("putAdmin: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  ///////////////////----------CLIENTS

  getConnectedClientInfo(): Observable<Client> {
    return this.get('api/clienti/client-info')
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  getClients(): Observable<Client[]> {
    return this.get('api/clienti/')
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response.Clienti;
      });
  }

  getClient(ClientId): Observable<Client> {
    return this.get('api/clienti/' + ClientId)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  postClient(Form): Observable<number> {
    return this.post('api/clienti', Form)
      .catch((error: any) => { console.log("postClient: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return response;
      });
  }

  putClient(Form: Client): Observable<boolean> {
    return this.put('api/clienti/' + Form.Id, Form)
      .catch((error: any) => { console.log("putClient: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  deleteClient(Id): Observable<boolean> {
    return this.delete('api/clienti/' + Id)
      .catch((error: any) => { console.log("deleteClient: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  getImpiantiByClientId(ClientId): Observable<Implant[]> {
    return this.get('api/clienti/' + ClientId + '/impianti/')
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response.Impianti;
      });
  }

  ///////////////////----------IMPLANTS

  putCambiaProprietario(idProprietario: number, idImpianto: number): Observable<NuovoProprietarioVM> {
    var model = {
      idProprietario: idProprietario,
    }
    return this.put('api/impianti/' + idImpianto + '/modificaProprietarioImpianto/', model)
      .catch((error: any) => { console.log("putCambiaProprietario: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return response;
      });
  }

  getImpianti(): Observable<Implant[]> {
    return this.get('api/impianti/')
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response.Impianti;
      });
  }

  getImpianto(IdImpianto): Observable<Implant> {
    return this.get('api/impianti/' + IdImpianto)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  postImpianto(Form): Observable<number> {
    return this.post('api/impianti', Form)
      .catch((error: any) => { console.log("postImplant: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return response;
      });
  }

  putImpianto(Form: Implant): Observable<boolean> {
    return this.put('api/impianti/' + Form.Id, Form)
      .catch((error: any) => { console.log("putImplant: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  deleteImpianto(IdImpianto): Observable<boolean> {
    return this.delete('api/impianti/' + IdImpianto)
      .catch((error: any) => { console.log("deleteImplant: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  putModificaPasswordImpianto(idImpianto: number, password: string): Observable<boolean> {
    var Form: any = {};
    Form.Id = idImpianto;
    Form.ConfermaPassword = password;
    return this.put('api/impianti/' + Form.Id + '/modificapassword', Form)
      .catch((error: any) => { console.log("putModificaPasswordImpianto: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  putModificaPasswordCliente(idCliente: number, password: string): Observable<boolean> {
    var Form: any = {};
    Form.Id = idCliente;
    Form.ConfermaPassword = password;
    return this.put('api/clienti/' + Form.Id + '/modificapassword', Form)
      .catch((error: any) => { console.log("putModificaPasswordCliente: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  getServiziImpianto(IdImpianto): Observable<ServizioPerImpianto[]> {
    return this.get('api/impianti/' + IdImpianto + '/servizi')
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  putAggiungiCarteConvertibili(idImpianto: number, quantita: number): Observable<boolean> {
    var Form: any = {};
    Form.Quantita = quantita;
    Form.Id = idImpianto;
    return this.put('api/impianti/' + idImpianto + '/aggiungicarteconvertibili', Form)
      .catch((error: any) => { console.log("putaggiungiCarteConvertibili: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  putAggiungiCreditiImpianto(idImpianto: number, crediti: number): Observable<boolean> {
    var Form: any = {};
    Form.Crediti = crediti;
    Form.Id = idImpianto;
    return this.put('api/impianti/' + idImpianto + '/aggiungicrediti', Form)
      .catch((error: any) => { console.log("putAggiungiCarteConvertibili: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  putRimuoviCreditiImpianto(idImpianto: number, crediti: number): Observable<boolean> {
    var Form: any = {};
    Form.Crediti = crediti;
    Form.Id = idImpianto;
    return this.put('api/impianti/' + idImpianto + '/rimuovicrediti', Form)
      .catch((error: any) => { console.log("putRimuoviCreditiImpianto: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  ///////////////////----------STORICO MOVIMENTI

  getStoricoMovimenti(page: number, pageRows: number, dataInizio: Date, dataFine: Date, searchText: string, getCountRows: boolean, impiantoId?: number, adminEvent?: boolean, implantEvent?: boolean): Observable<Eventi> {

    var url = 'api/StoricoMovimenti/' + page + '/' + pageRows + '?';

    var objUrl = { impiantoId: impiantoId, adminEvent: adminEvent, implantEvent: implantEvent, dataInizio: dataInizio.toISOString(), dataFine: dataFine.toISOString(), searchText: searchText, getCount: getCountRows };

    var params = $.param(objUrl);

    url = url + params;

    return this.get(url)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  getExportStoricoMovimenti(dataInizio: Date, dataFine: Date, searchText: string, impiantoId?: number, adminEvent?: boolean, implantEvent?: boolean): Observable<string> {

    var url = 'api/StoricoMovimenti/ExportStoricoMovimenti/?';

    var objUrl = { impiantoId: impiantoId, adminEvent: adminEvent, implantEvent: implantEvent, dataInizio: dataInizio.toISOString(), dataFine: dataFine.toISOString(), searchText: searchText };

    var params = $.param(objUrl);

    url = url + params;

    return this.post(url, null)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response.NameFile;
      });
  }
  ///////////////////----------GESTIONE SERVIZI

  getServizi(): Observable<Servizio[]> {
    return this.get('api/servizi/')
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response.Servizi;
      });
  }

  getServizio(IdServizio): Observable<Servizio> {
    return this.get('api/servizi/' + IdServizio)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  postServizio(Form): Observable<number> {
    return this.post('api/servizi', Form)
      .catch((error: any) => { console.log("postServizio: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return response;
      });
  }

  putServizio(Form: Servizio): Observable<boolean> {
    return this.put('api/servizi/' + Form.Id, Form)
      .catch((error: any) => { console.log("putServizio: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  checkDeleteServizio(IdServizio): Observable<any> {
    return this.get('api/servizi/CheckDelete/' + IdServizio)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  deleteServizio(IdServizio): Observable<boolean> {
    return this.delete('api/servizi/' + IdServizio)
      .catch((error: any) => { console.log("deleteServizio: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  ///////////////////----------GESTIONE OFFERTE

  getOfferte(): Observable<Offerta[]> {
    return this.get('api/offerte/')
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response.Offerte;
      });
  }

  getOfferta(IdOfferta): Observable<Offerta> {
    return this.get('api/offerte/' + IdOfferta)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  postOfferta(Form): Observable<number> {
    return this.post('api/offerte', Form)
      .catch((error: any) => { console.log("postOfferta: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return response;
      });
  }

  putOfferta(Form: Offerta): Observable<boolean> {
    return this.put('api/offerte/' + Form.Id, Form)
      .catch((error: any) => { console.log("putOfferta: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  deleteOfferta(IdOfferta): Observable<boolean> {
    return this.delete('api/offerte/' + IdOfferta)
      .catch((error: any) => { console.log("deleteOfferta: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  ///////////////////----------RICHIESTA CREDITI

  getRichieste(IdImpianto: number, soloPendenti: boolean): Observable<Richiesta[]> {
    var query = {
      IdImpianto: IdImpianto,
      soloPendenti: soloPendenti
    };
    let params = new URLSearchParams();
    for (let key in query)
      params.set(key, query[key]);

    return this.get('api/richiestacrediti/getrichieste?' + params.toString())
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response.Richieste;
      });
  }

  getRichiesta(IdRichiesta): Observable<Richiesta> {
    return this.get('api/richiestacrediti/getrichiesta/' + IdRichiesta)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  accettaRichiesta(IdRichiesta): Observable<boolean> {
    return this.get('api/richiestacrediti/accetta/' + IdRichiesta)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  rifiutaRichiesta(IdRichiesta): Observable<boolean> {
    return this.get('api/richiestacrediti/rifiuta/' + IdRichiesta)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  ///////////////////----------CASSE

  deleteCassa(Id): Observable<boolean> {
    return this.delete('api/cassa/' + Id)
      .catch((error: any) => { console.log("deleteCassa: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  postCassa(nomeCassa, impiantoId, tipologiaCassa, tipologiaErogazioneCassa, SogliaMaxRicaricaAutomatica, SogliaMinRicaricaAutomatica, Servizi): Observable<number> {
    var model = {
      NomeCassa: nomeCassa,
      ImpiantoId: impiantoId,
      TipologiaCassa: tipologiaCassa,
      Servizi: Servizi,
      tipologiaErogazioneCassa: tipologiaErogazioneCassa,
      SogliaMaxRicaricaAutomatica: SogliaMaxRicaricaAutomatica,
      SogliaMinRicaricaAutomatica: SogliaMinRicaricaAutomatica
    }
    return this.post('api/cassa', model)
      .catch((error: any) => { console.log("postCassa: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return response;
      });
  }

  putCassa(idCassa, impiantoId, nomeCassa, tipologiaCassa, tipologiaErogazioneCassa, SogliaMaxRicaricaAutomatica, SogliaMinRicaricaAutomatica, Servizi): Observable<boolean> {
    var model = {
      NomeCassa: nomeCassa,
      ImpiantoId: impiantoId,
      TipologiaCassa: tipologiaCassa,
      Servizi: Servizi,
      tipologiaErogazioneCassa: tipologiaErogazioneCassa,
      SogliaMaxRicaricaAutomatica: SogliaMaxRicaricaAutomatica,
      SogliaMinRicaricaAutomatica: SogliaMinRicaricaAutomatica
    }
    return this.put('api/Cassa/' + idCassa, model)
      .catch((error: any) => { console.log("putCassa: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  getCasseImpianto(ImpiantoId): Observable<Cassa[]> {
    return this.get('api/Cassa/CasseImpianto/' + ImpiantoId)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  getCassaById(CassaId): Observable<Cassa> {
    return this.get('api/Cassa/GetCassaById/' + CassaId)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }



  ///////////////////----------FOTO TOTEM

  getInfoCassaBanner(idImpianto: number): Observable<InfoCasseBanner> {
    return this.get('api/Impianti/info-casse-banner/' + idImpianto)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  getListaFotoTotem(idImpianto: number): Observable<FotoTotem[]> {
    return this.get('api/Impianti/GetImpiantoFotoTotem/' + idImpianto)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response.TotemImgs;
      });
  }

  getFotoTotem(idFotoTotem): Observable<FotoTotem> {
    return this.get('api/Impianti/GetFotoTotem' + idFotoTotem)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  putFotoTotem(Form: FotoTotem): Observable<boolean> {
    return this.put('api/Impianti/PutFotoTotem/' + Form.Id, Form)
      .catch((error: any) => {
        console.log("putFotoTotem: ", error);
        return Observable.throw(error);
      })
      .map((response: any) => {
        return true;
      });
  }

  postFotoTotem(Form: FotoTotem): Observable<boolean> {
    return this.post('api/Impianti/postFotoTotem', Form)
      .catch((error: any) => {
        console.log("postFotoTotem: ", error);
        return Observable.throw(error);
      })
      .map((response: any) => {
        return true;
      });
  }

  deleteFotoTotem(idFotoTotem): Observable<boolean> {
    return this.delete('api/Impianti/deleteFotoTotem/' + idFotoTotem)
      .catch((error: any) => { console.log("deleteFotoTotem: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  ///////////////////----------LISTINI

  getListiniImpianto(ImpiantoId): Observable<Listino[]> {
    return this.get('api/Listini/ListiniImpianto/' + ImpiantoId)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response.Listini;
      });
  }

  postListino(nomeListino, impiantoId): Observable<number> {
    var a = {
      Nome: nomeListino,
      ImpiantoId: impiantoId
    }
    return this.post('api/listini', a)
      .catch((error: any) => { console.log("postListino: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return response;
      });
  }

  putListino(idListino, nomeListino): Observable<boolean> {
    var a = {
      Nome: nomeListino
    }
    return this.put('api/listini/' + idListino, a)
      .catch((error: any) => { console.log("putListino: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  deleteListino(idListino): Observable<boolean> {
    return this.delete('api/listini/' + idListino)
      .catch((error: any) => { console.log("deleteListino: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  getServiziListino(IdListino): Observable<ServizioPerListino[]> {
    return this.get('api/listini/' + IdListino + '/servizilistino')
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  putServiziPerListino(idListino: number, serviziPerListino: ServizioPerListino[]): Observable<boolean> {
    return this.put('api/listini/servizilistino/' + idListino, serviziPerListino)
      .catch((error: any) => { console.log("putServiziPerListino: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  ///////////////////----------OPERATORI

  getOperatoriImpianto(idImpianto: number): Observable<OperatoreImpianto[]> {
    return this.get('api/OperatoreImpianto/OperatoriImpianto/' + idImpianto)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response.Operatori;
      });
  }

  getOperatore(idOperatore): Observable<OperatoreImpianto> {
    return this.get('api/OperatoreImpianto/Operatore/' + idOperatore)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  putOperatore(Form: OperatoreImpianto): Observable<boolean> {
    return this.put('api/OperatoreImpianto/' + Form.Id, Form)
      .catch((error: any) => {
        console.log("putOperatoreImpianto: ", error);
        return Observable.throw(error);
      })
      .map((response: any) => {
        return true;
      });
  }

  postOperatore(Form: OperatoreImpianto): Observable<boolean> {
    return this.post('api/OperatoreImpianto', Form)
      .catch((error: any) => {
        console.log("postOperatore: ", error);
        return Observable.throw(error);
      })
      .map((response: any) => {
        return true;
      });
  }

  deleteOperatore(idOperatore): Observable<boolean> {
    return this.delete('api/OperatoreImpianto/' + idOperatore)
      .catch((error: any) => { console.log("deleteOperatore: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  putModificaPasswordOperatore(idUser: number, password: string): Observable<boolean> {
    var Form: any = {};
    Form.Id = idUser;
    Form.ConfermaPassword = password;
    return this.put('api/OperatoreImpianto/operatore/' + Form.Id + '/modificapassword', Form)
      .catch((error: any) => { console.log("putModificaPasswordOperatore: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  putCheckEmailOperatoreImpianto(Form: CheckEmailBM): Observable<CheckEmailVM> {
    return this.put('api/OperatoreImpianto/CheckEmailOperatoreImpianto', Form)
      .catch((error: any) => {
        console.log("putCheckEmailOperatoreImpianto: ", error);
        return Observable.throw(error);
      })
      .map((response: any) => {
        return response;
      });
  }
}




// WEBPACK FOOTER //
// ./src/app/services/admin.service.ts